import { HubJsonRpcRequest } from '../../../api/HubJsonRpcRequest';
import { HubApiMethods } from '../../../constants/HubApiMethods';

export type RequestEmailOtpRequest = {
    email: string,
    locale: string
    current_entry_point: string
}

type RequestEmailOtpSuccessResponse = {
    status: number
};

type RequestEmailOtpErrorResponse = {
    message?: string,
    error: {
        message?: string
    }
};

export type RequestEmailOtpResponse = RequestEmailOtpSuccessResponse | RequestEmailOtpErrorResponse;

export function requestEmailOtp(data: RequestEmailOtpRequest): Promise<RequestEmailOtpResponse> {
    return HubJsonRpcRequest.makeRequest<RequestEmailOtpResponse, RequestEmailOtpRequest>(
        HubApiMethods.REQUEST_EMAIL_OTP_AUTH,
        data,
        window.app.deviceIdentifier
    );
}
